import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import UserConditionService from '../../../services/userConditionService';
import AuthService from '../../../services/authService';
import Growl from '../../../common/components/alertMessage/growl';
import { UserForGridModel } from "../../../models/user";
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import { UserConditionModel } from '../../../models/user/userConditionModel';
import { UserConditionTypeModel } from '../../../models/user/userConditionTypeModel';
import UserConditionList from './userConditionList';
import UserConditionAddEditComponent from './userConditionAddEditComponent';
import { UserConditionType } from "../../../common/enums";
import { connect } from 'react-redux';
import { enumToDropdownArray, fomatDateTimeAsString, fomatDateTimeAsStringWithLang } from '../../../common/functions/helperFunctions';
import { UserConditionListFilterModel } from '../../../models/user/userConditionListFilterModel';
import UserConditionViewComponent from './userConditionViewComponent';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import * as Constants from '../../../common/constants';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { faTimes, faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCheck, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { UserPersonalConditionModel } from '../../../models/user/userPersonalConditionModel';
import Switch from '@material-ui/core/Switch';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import { ConditionUnitRangeModel } from "../../../models/user/conditionUnitRangeModel";

interface IProps {
	history: any;
	location: any;
	userId: number;
	lang: string;
}

interface IState {
	isLoading: boolean;
	totalRecordsCount: number;
	users: Array<UserForGridModel>;
	isVisibleDialog: boolean;
	currentConditionId: number,
	userCondtitions: Array<UserConditionModel>;
	dialogHeader: string;
	isVisibleConfirmDialog: boolean;
	deleteValidationMessage: string;
	selectedConditionId: number;
	first: number;
	rows: number;
	totalRecords: number;
	conditionType: Array<ConditionDropdownModel>;
	filters: UserConditionListFilterModel;
	startDate: boolean;
	endDate: boolean;
	isVisibleView: boolean;
	expandedConditions: Array<UserConditionModel>;
	expanded: string;
	tabActiveIndex: number;
	currentFilters: UserConditionListFilterModel,
	selectedConditionValue: number,
	currentConditionValue: number,
	addNew: boolean;
	selectedTypes: Array<ConditionDropdownModel>,
	newCondition: string,
	personalCondition: ConditionDropdownModel;
	personalConditions: Array<UserPersonalConditionModel>;
	popover: boolean;
	anchorEl: any;
	isLoadingSecond: boolean;
	isVisibleConfirmPersonalDialog: boolean;
	minResult: number;
	maxResult: number;
}

const initFrom = 0;
const numberOfRows = 20

class UserConditionComponent extends React.Component<IProps, IState> {

	userConditionService = new UserConditionService();
	authService = new AuthService();
	growl: any;
	growlSecond: any;

	constructor(props: IProps) {
		super(props);
		this.state = {
			isLoading: false,
			totalRecordsCount: 0,
			users: new Array<UserForGridModel>(0),
			isVisibleDialog: false,
			currentConditionId: 0,
			userCondtitions: new Array<UserConditionModel>(),
			dialogHeader: '',
			isVisibleConfirmDialog: false,
			deleteValidationMessage: '',
			selectedConditionId: 0,
			first: initFrom,
			rows: numberOfRows,
			totalRecords: 0,
			conditionType: new Array<ConditionDropdownModel>(0),
			filters: new UserConditionListFilterModel(),
			currentFilters: new UserConditionListFilterModel(),
			startDate: false,
			endDate: false,
			isVisibleView: false,
			expandedConditions: new Array<UserConditionModel>(0),
			expanded: '',
			tabActiveIndex: 0,
			selectedConditionValue: 0,
			addNew: false,
			currentConditionValue: 0,
			selectedTypes: new Array<ConditionDropdownModel>(0),
			newCondition: '',
			personalConditions: Array<UserPersonalConditionModel>(0),
			personalCondition: new ConditionDropdownModel(),
			popover: false,
			anchorEl: null,
			isLoadingSecond: false,
			isVisibleConfirmPersonalDialog: false,
			minResult: 0,
			maxResult: 0
		};
	}

	componentDidMount() {
		window.addEventListener('scroll', this.onScroll);
		this.getConditions(true);
	}

	conditionEnumToDropdownArray(enumName, isSystem: boolean) {
		let enumAsArray: Array<ConditionDropdownModel> = [];
		for (var n in enumName) {
			if (typeof enumName[n] === 'number') {
				enumAsArray.push({
					value: +enumName[n], label: Translate(n), isSystem: isSystem,
					isVisible: this.state.userCondtitions.some(r => r.isSystemType == true && r.userConditionTypeId == +enumName[n] ? true : false)
				});
			}
		}
		return enumAsArray;
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll);
	}

	onScroll = () => {
		let scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
		if (window.innerHeight + scrollY >= document.body.offsetHeight - 250 &&
			this.state.totalRecords > this.state.userCondtitions.length && !this.state.isLoading) {
			this.paginatorClick({ first: this.state.first + this.state.rows }, false);
		}
	};

	getConditions(isInit: boolean) {
		this.setState({
			isLoading: true
		});

		if (this.authService.isAuthenticated()) {
			let filter: UserConditionListFilterModel = new UserConditionListFilterModel();

			let userId = this.props.userId ? this.props.userId : this.authService.getUserId();

			this.userConditionService.getAllUserConditions(this.state.first, this.state.rows, filter).then(
				(data: any) => {
					if (data) {
						if (isInit) {
							this.setState({
								isLoading: false,
								userCondtitions: [...data.userConditions],
								totalRecords: data.totalRecords
							});
						}
						else {
							this.setState({
								isLoading: false,
								userCondtitions: [...this.state.userCondtitions, ...data.userConditions],
								totalRecords: data.totalRecords
							});
						}
					}
				})
				.catch(error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				});
		}
	}

	showEditDialog = (show: boolean) => {
		this.setState({
			isVisibleDialog: show
		});
	};

	handleAddAndEditClick = (condId: number) => {
		this.setState({
			dialogHeader: Translate('EditCondition'),
			currentConditionId: condId,
			isVisibleDialog: true
		});
	};

	handleCloseAddEditClick = (getCond?: boolean) => {
		if (getCond) {
			this.setState({
				isVisibleDialog: false,
				first: initFrom,
				rows: numberOfRows
			}, () => this.getConditions(true));
		}
		else {
			this.setState({
				isVisibleDialog: false,
				first: initFrom,
				rows: numberOfRows
			});
		}
	}

	handleDeleteClick = (conditionId: number) => {
		this.setState({
			isVisibleConfirmDialog: true,
			selectedConditionId: conditionId,
			deleteValidationMessage: Translate('ConditionConfirm') + '?'
		});
	}

	deleteCondition = (id: number) => {
		this.setState({
			isVisibleConfirmDialog: false,
			isLoading: true
		});

		this.userConditionService.deleteCondition(id)
			.then(
				data => {
					this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
					this.setState({ first: initFrom, rows: numberOfRows }, () => this.getConditions(true));
				},
				error => {
					this.growl.show({ severity: 'error', summary: Translate(error.message) });
					this.setState({
						isLoading: false
					});
				});
	}

	paginatorClick = (e, isInit: boolean) => {
		this.setState({ first: e.first }, () => this.getConditions(isInit));
	}

	handleChange = (key, value) => {
		const userFilter: UserConditionListFilterModel = { ...this.state.currentFilters };
		userFilter[key] = value;
		this.setState({ currentFilters: { ...userFilter } })
	};

	handleChekbox = (key) => {
		let dateEarly = this.getMonthEarlier(new Date().toString())
		if (key == 0) {
			this.setState(prevState => ({
				startDate: !prevState.startDate
			}), () => this.handleChange('startDate', dateEarly));
		}
		else {
			this.setState(prevState => ({
				endDate: !prevState.endDate
			}), () => this.handleChange('endDate', new Date()));
		}
	}

	handleCloseView = () => {
		this.setState({ isVisibleView: false });
	}

	getFiltersummary = () => {
		let nameSet: any = null;
		let startSet: any = null;
		let endSet: any = null;

		if (this.state.selectedConditionValue > 0) {
			let name: string = '';
			for (let cond of this.state.conditionType) {
				if (cond.value == this.state.selectedConditionValue) {
					name = cond.label
				}
			}
			nameSet =
				<>
					<span style={{ color: '#999' }}>{Translate('Characteristic')}</span>:
					<span style={{ fontWeight: 600 }}> {name} </span>
				</>
		}

		if (this.state.filters && this.state.filters.startDate) {
			startSet =
				<>
					<span style={{ color: '#999' }}>{Translate('From')}</span>:
					<span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDateAsStringWithLang(new Date(this.state.filters.startDate), this.props.lang)} </span>
				</>
		}

		if (this.state.filters && this.state.filters.endDate) {
			endSet =
				<>
					<span style={{ color: '#999' }}>{Translate('To')}</span>:
					<span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDateAsStringWithLang(new Date(this.state.filters.endDate), this.props.lang)} </span>
				</>
		}

		let summary =
			<p style={{ marginTop: 0 }}>
				{nameSet}
				{startSet}
				{endSet}
			</p>

		return summary;
	}

	getMonthEarlier = (currentDate: string) => {
		let d = new Date(currentDate);
		d.setMonth(d.getMonth() - 1);
		return d;
	}

	handleDropChange = (cond) => {
		this.setState({ currentConditionValue: cond });
	}

	addNewToList = (event) => {
		event.preventDefault();
		this.setState({ addNew: true, selectedTypes: new Array<ConditionDropdownModel>(0) });
	}

	handleCancelAddNewButton = () => {
		this.setState({
			addNew: false,
			selectedTypes: new Array<ConditionDropdownModel>(0),
			newCondition: '',
			first: initFrom,
			rows: numberOfRows
		}, () => this.getConditions(true));
	}

	selectTypes = (condition: ConditionDropdownModel, isChecked: boolean) => {
		this.setState({ isLoadingSecond: true });
		let uCondition: UserConditionModel = new UserConditionModel();
		uCondition.isSystemType = condition.isSystem;
		condition.isVisible = isChecked;
		uCondition.userConditionTypeId = condition.value;
		uCondition.isVisible = isChecked;
		this.userConditionService.addUserCondition(uCondition)
			.then(
				(data) => {
					this.setState({
						isLoadingSecond: false
					});
				},
				error => {
					this.handleCloseAddEditClick();
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoadingSecond: false
					});
				}
			);
	}

	handleDeletePersonalClick = (personalCondition: ConditionDropdownModel, e) => {
		e.preventDefault();
		this.setState({
			isVisibleConfirmPersonalDialog: true,
			personalCondition: personalCondition,
			deleteValidationMessage: Translate('PersonalConditionConfirm')
		});
	}

	handleClick = (e) => {
		e.preventDefault();
		this.setState({ popover: true, anchorEl: e.currentTarget });
	}

	handleClose = () => {
		this.setState({
			popover: false,
			newCondition: '',
			minResult: 0,
			maxResult: 0,
		})
	}

	handleAddCharacteristicKeyPress = (e) => {
		if (e.key === 'Enter' && this.state.newCondition && this.state.newCondition.trim() != '') {
			this.handleAddButton(e);
		}
	}

	handleAddButton = (e) => {
		e.preventDefault();
		if (this.state.conditionType.some(c => c.label.toLocaleLowerCase() == this.state.newCondition.trim().toLocaleLowerCase())) {
			this.growlSecond.show({ severity: 'warning', summary: Translate('Characteristic already exist') });
			return;
		}
		this.setState({
			isLoading: true
		});

		let newPersonal: UserPersonalConditionModel = new UserPersonalConditionModel();
		newPersonal.personalConditionTypeName = this.state.newCondition;
		newPersonal.minValue = this.state.minResult;
		newPersonal.maxValue = this.state.maxResult;
		this.userConditionService.createPersonalCondition(newPersonal)
			.then(
				(data) => {
					let condition: ConditionDropdownModel = new ConditionDropdownModel();
					condition.label = JSON.parse(JSON.stringify(this.state.newCondition));
					condition.value = data;
					condition.isSystem = false;
					condition.isVisible = false;
					this.setState({
						isLoading: false,
						conditionType: this.state.conditionType.concat(condition),
						newCondition: '',
						minResult: 0,
						maxResult: 0,
						popover: false
					});
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	newConditionChange = (value) => {
		this.setState({ newCondition: value });
	}

	openDialog = () => {
		this.setState({ isLoading: true });
		this.userConditionService.getPersonalConditions()
			.then(
				(data) => {
					this.setState({
						isLoading: false,
						personalConditions: data,
						conditionType: this.conditionEnumToDropdownArray(UserConditionType, true),
						addNew: true
					}, this.addPersonalsToDropdown);
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	addPersonalsToDropdown = () => {
		if (this.state.personalConditions && this.state.personalConditions.length > 0) {
			let conditions: Array<ConditionDropdownModel> = new Array<ConditionDropdownModel>(0);
			for (let cond of this.state.personalConditions) {
				let condition: ConditionDropdownModel = new ConditionDropdownModel();
				condition.value = cond.personalConditionTypeId;
				condition.label = cond.personalConditionTypeName;
				condition.isSystem = false;
				condition.isVisible = cond.isVisible;
				conditions.push(condition);
			}
			this.setState({ conditionType: this.state.conditionType.concat(conditions) });
		}
	}

	getPersonalConditions = (isFromDelete: boolean) => {
		this.setState({ isLoading: true });
		this.userConditionService.getPersonalConditions()
			.then(
				(data) => {
					if (isFromDelete) {
						this.setState({
							isLoading: false,
							personalConditions: data
						}, this.addPersonalsToDropdown);
					}
					else {
						this.setState({
							isLoading: false,
							personalConditions: data,
						});
					}
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	removePersonalCondition = (personalCondition: ConditionDropdownModel) => {
		this.setState({ isLoadingSecond: true });
		this.userConditionService.deletePersonalCondition(personalCondition.value)
			.then(
				(data) => {
					if (data == false) {
						this.growlSecond.show({ severity: 'error', summary: Translate('Characteristic is used') });
						this.setState({ isLoadingSecond: false });
						return;
					}
					this.growlSecond.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
					this.setState({
						isLoadingSecond: false,
						conditionType: this.conditionEnumToDropdownArray(UserConditionType, true),
						selectedTypes: new Array<ConditionDropdownModel>(0)
					}, () => this.getPersonalConditions(true));
				},
				error => {
					this.growlSecond.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoadingSecond: false
					});
				}
			);
	}

	changeMinAndMax = (type, value) => {
		if (type == 'minResult') {
			this.setState({ minResult: value });
		}
		if (type == 'maxResult') {
			this.setState({ maxResult: value });
		}
	}


	public render() {
		const { isLoading, isVisibleDialog, userCondtitions, filters, expanded,
			dialogHeader, selectedConditionId, anchorEl, rows, totalRecords, conditionType,
			selectedTypes, popover, isVisibleView, expandedConditions, tabActiveIndex, selectedConditionValue } = this.state;

		let showAllLink = false;
		if (filters.startDate || filters.endDate || selectedConditionValue > 0) {
			showAllLink = true
		}

		return (
			<div className="app-content">
				<div>

					<Growl ref={(el) => this.growl = el} />
					<h2>{Translate('My Condition')}</h2>

					<Fab color="primary" focusRipple={false} aria-label="Add" size="small" onClick={() => this.openDialog()} className="floating-action-button">
						<AddIcon />
					</Fab>


					<div className="user-condition-grid">

						{filters && (filters.startDate || filters.endDate || selectedConditionValue > 0) ?
							<>
								<p style={{ marginBottom: 0, fontWeight: 600 }}>{Translate('Filters') + ":"}</p>
								{this.getFiltersummary()}
							</>
							: null}

						<UserConditionList userConditions={userCondtitions}
							lang={this.props.lang}
							addClick={this.handleAddAndEditClick} />
					</div>
					{/* {totalRecords > rows ?
                        <Paginator totalRecords={totalRecords} first={first} rows={rows} onPageChange={(e) => this.paginatorClick(e)}></Paginator>
                        : null} */}
					{isLoading ? <Spinner inlineSpinner={true} /> : null}
					{!isLoading && (!userCondtitions || userCondtitions.length == 0) ? Translate("No records found") : null}
				</div>

				{isVisibleDialog ? <UserConditionAddEditComponent isVisible={isVisibleDialog}
					cancelClick={this.handleCloseAddEditClick}
					selectedConditionId={this.state.currentConditionId}
					dialogHeader={dialogHeader}
					lang={this.props.lang}></UserConditionAddEditComponent>
					: null}

				<ConfirmDialog
					headerTitle={Translate("Confirm Dialog")}
					isVisible={this.state.isVisibleConfirmDialog}
					yesClick={() => { this.deleteCondition(selectedConditionId) }}
					noClick={() => { this.setState({ isVisibleConfirmDialog: false, deleteValidationMessage: '' }) }}>
					{this.state.deleteValidationMessage}
				</ConfirmDialog>
				<MuiThemeProvider theme={Constants.smallDialogTheme}>
					<Dialog
						open={this.state.addNew}
						onClose={this.handleCancelAddNewButton}
						fullWidth={window.innerWidth < Constants.device.desktop}
					>
						<Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelAddNewButton}>{Translate("Choose characteristic")}</Modal.DialogTitle>
						<Modal.DialogContent>
							{this.state.isLoadingSecond ? <Spinner /> : null}
							<Growl ref={(el) => this.growlSecond = el} />


							<div style={{ width: '100%', float: 'left', maxHeight: '400px', overflowY: 'auto', marginBottom: 15 }}>
								<ul className="list-items">
									{this.state.conditionType && this.state.conditionType.length > 0 ?
										this.state.conditionType.map((m: ConditionDropdownModel) =>
											<li key={m.value + 'data-cond'}>
												<div className="item-actions" style={{ paddingLeft: 5 }}>
													<Switch
														checked={m.isVisible}
														onChange={(e) => this.selectTypes(m, e.target.checked)}
														value="checkedB"
														color="primary"
													/>
												</div>
												<div className="item-name-with-radio" onClick={() => this.selectTypes(m, !m.isVisible)}>
													{m.label}
												</div>
												{
													m.isSystem ?
														null
														:
														<div className="item-actions" style={{ paddingLeft: 5 }}>
															<a href='' onClick={(e) => this.handleDeletePersonalClick(m, e)} title={Translate('Remove')} >
																<FontAwesomeIcon icon={faTimesCircle} style={{ color: '#f50057', fontSize: '1.3em', margin: '0 2px' }} />
															</a>
														</div>
												}
											</li>
										) : Translate('No records found')}
								</ul>
							</div>
							<div>
								<a href="" aria-describedby={"boo"} onClick={(e) => this.handleClick(e)}>
									{Translate("New Characteristic")}
								</a>

								<Popover
									id={"boo"}
									open={popover}
									anchorEl={anchorEl}
									onClose={this.handleClose}
									anchorOrigin={{
										vertical: 'top',
										horizontal: 'right',
									}}
									transformOrigin={{
										vertical: 'bottom',
										horizontal: 'right',
									}}
								>
									<div style={{ padding: 20 }}>
										<div>
											<TextField
												autoComplete="off"
												label={Translate('Name of characteristic')}
												type="text"
												value={this.state.newCondition || ''}
												onKeyPress={this.handleAddCharacteristicKeyPress}
												onChange={(e) => this.newConditionChange(e.target['value'])}></TextField>
										</div>
										<div>
											<TextField
												autoComplete="off"
												label={Translate('Min')}
												type="number"
												value={this.state.minResult || ''}
												onKeyPress={this.handleAddCharacteristicKeyPress}
												onChange={(e) => this.changeMinAndMax('minResult', e.target['value'])}></TextField>
											<TextField
												autoComplete="off"
												label={Translate('Max')}
												type="number"
												value={this.state.maxResult || ''}
												onKeyPress={this.handleAddCharacteristicKeyPress}
												onChange={(e) => this.changeMinAndMax('maxResult', e.target['value'])}></TextField>
										</div>
										<div style={{ margin: "10px 0 10px 0", width: '100%', float: 'right', textAlign: 'right' }}>
											<Button variant="contained" size="small" onClick={this.handleClose} style={{ marginRight: 10 }}>
												<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
												{Translate('Cancel')}
											</Button>
											<Button variant="contained" size="small" color="primary" onClick={(e) => this.handleAddButton(e)}
												disabled={!this.state.newCondition || this.state.newCondition.trim() == ''}>
												<FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
												{Translate('Create')}
											</Button>
										</div>
									</div>
								</Popover>

							</div>
						</Modal.DialogContent>
						<Modal.DialogActions>
							<div>
								<Button variant="contained" size="small" onClick={this.handleCancelAddNewButton} style={{ marginRight: '10px' }}>
									<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
									{Translate('Close')}
								</Button>
							</div>
						</Modal.DialogActions>
					</Dialog>
				</MuiThemeProvider>

				<ConfirmDialog
					headerTitle={Translate("Confirm Dialog")}
					isVisible={this.state.isVisibleConfirmPersonalDialog}
					yesClick={(e) => { this.setState({ isVisibleConfirmPersonalDialog: false }, () => this.removePersonalCondition(this.state.personalCondition)) }}
					noClick={() => { this.setState({ isVisibleConfirmPersonalDialog: false, deleteValidationMessage: '' }) }}>
					{this.state.deleteValidationMessage}
				</ConfirmDialog>
			</div>
		)
	}
}

class ConditionDropdownModel {
	value: number;
	label: string;
	isSystem: boolean;
	isVisible: boolean;
}

const mapsStateToProps = state => {
	return {
		lang: state.common.lang
	};
}

export default connect(mapsStateToProps)(UserConditionComponent);